import { FunctionComponent } from "react";
import { Route, Routes, useParams } from "react-router-dom";

import { ListOverview } from "./pages/ListOverview/ListOverview";

import { Unassigned } from "./pages/Unassigned/Unassigned";
import { ListCreate } from "./pages/ListCreate/ListCreate";
import { ListEditDetails } from "./pages/ListEditDetails/ListEditDetails";
import { ListEditSource } from "./pages/ListEditSource/ListEditSource";
import { ListEditFilter } from "./pages/ListEditFilter/ListEditFilter";
import { ListEditSetting } from "./pages/ListEditSetting/ListEditSetting";
import { ListEditCopywriting } from "./pages/ListEditCopywriting/ListEditCopywriting";
import { ListEditSignals } from "./pages/ListEditSignals/ListEditSignals";

// Remount the list detail page whenever the list id changes. Navigating from one list detail to
// another keeps the route element mounted (same route, new param), so mount-time state — e.g. the
// search box seeded from the `searchTerm` URL param ("Also on these lists" deep-links) — would
// silently carry over from the previous list instead of re-initializing.
const UnassignedByListId: FunctionComponent = () => {
	const { id } = useParams();

	return <Unassigned key={id} />;
};

export const List: FunctionComponent = () => {
	return (
		<Routes>
			<Route element={<ListOverview />} path="/" />
			<Route element={<ListEditDetails />} path="/create/details/:id" />
			<Route element={<ListEditFilter />} path="/create/filter/:id" />
			<Route element={<ListEditSource />} path="/create/source/:id" />
			<Route element={<ListEditSetting />} path="/create/settings/:id" />
			<Route element={<ListEditCopywriting />} path="/create/copywriting/:id" />
			<Route element={<ListEditSignals />} path="/create/signals/:id" />

			<Route element={<ListCreate />} path="/create" />
			<Route element={<UnassignedByListId />} path="/detail/:id" />
		</Routes>
	);
};
